import type { ScopeBarProps } from './types';

// Scope toggle (All floor plans / Selected N) plus the Run button. Switching
// the scope only updates state — the reviewer re-runs the check manually.
export const ScopeBar = ({ scope, selectedCount, running, applying, hasRun, onScope, onRun }: ScopeBarProps) => (
  <div className="syntax-scopebar">
    <div className="syntax-scope-toggle">
      <button
        type="button"
        className={`syntax-scope-btn${scope === 'all' ? ' active' : ''}`}
        onClick={() => onScope('all')}
      >
        All floor plans
      </button>
      <button
        type="button"
        className={`syntax-scope-btn${scope === 'selected' ? ' active' : ''}`}
        disabled={selectedCount === 0}
        title={selectedCount === 0 ? 'Select plans on the Annotation tab first' : undefined}
        onClick={() => onScope('selected')}
      >
        Selected ({selectedCount})
      </button>
    </div>
    <button className="btn-review-action btn-publish" onClick={onRun} disabled={running || applying}>
      {running ? (
        <>
          <span className="ann-btn-spinner" />
          Running…
        </>
      ) : (
        hasRun ? 'Re-run' : 'Run check'
      )}
    </button>
  </div>
);
